import React from 'react'
import styled from 'styled-components'
import Select from 'react-select'

import colors from 'styles/colors'

const styles = {  
  control: provided => ({
    ...provided,
    backgroundColor: colors.green,
    borderRadius: 0,
    borderColor: colors.white + ' !important',
    boxShadow: 'none',
    cursor: 'pointer',
    minHeight: '36px',
    fontSize: '13px'
  }),
  placeholder: provided => ({
    ...provided,
    color: colors.white,
    fontSize: '13px'
  }),
  valueContainer: provided => ({
    ...provided,
    padding: '2px 12px'
  }),
  singleValue: provided => ({
    color: colors.white
  }),
  indicatorSeparator: (provided, state) => ({
    display: 'none'
  }),
  menu: provided => ({
    ...provided,
    margin: 0,
    borderRadius: 0,
    backgroundColor: colors.white,
    border: `solid 1px ${colors.white}`,
    width: '100%'
  }),
  menuList: provided => ({
    ...provided,
    padding: 0,
    color: colors.black,
    width: '100%'
  }),
  option: (provided, state) => {
    let backgroundColor = colors.white
    
    if ( state.isFocused )
      backgroundColor = colors.xxltGreen
    
    if ( state.isSelected )
      backgroundColor = colors.ltGreen
    
    return {
      ...provided,
      color: colors.black,
      backgroundColor,
      cursor: 'pointer',
      fontSize: '11px',
      height: '28px',
      ':active': {        
        backgroundColor: colors.ltGreen
      }
    }
  }
}

const IconEl = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 36px;
  font-size: 11px;
`

const Icon = ({ innerRef, innerProps, selectProps }) => {
  const direction = selectProps.menuIsOpen ? 'up' : 'down'
  
  return (
    <IconEl ref={innerRef} {...innerProps}>     
      <span className={`icon-chevron-${direction}`} />
    </IconEl>
  )
}

const Dropdown = ({ styles: containerStyles, ...props }) => {
  
  return (
    <Select
        {...props}
        styles={{
          ...styles,
          container: provided => ({
            ...provided,
            ...containerStyles
          })
        }}
        components={{
          DropdownIndicator: Icon
        }}        
    />    
  )
}

export default Dropdown
